import { render, staticRenderFns } from "./promotionrule.vue?vue&type=template&id=4d93e2be&scoped=true"
import script from "./promotionrule.vue?vue&type=script&lang=js"
export * from "./promotionrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93e2be",
  null
  
)

export default component.exports